import { Button } from "@/components/ui/button";

export const ProjectHeader = () => {
  return (
    <div className="text-center space-y-4">
      <h1 className="text-4xl font-bold bg-gradient-to-r from-orange-500 to-yellow-300 text-transparent bg-clip-text">
        Create Your Blog Post
      </h1>
      <p className="text-gray-400 max-w-2xl mx-auto">
        Create and customize your blog post. Need help? 
        <Button 
          variant="link" 
          className="text-blue-400 hover:text-blue-300"
          onClick={() => window.open("https://t.me/bytehype", "_blank")}
        >
          Contact us on Telegram
        </Button>
      </p>
    </div>
  );
};